import { render, staticRenderFns } from "./myTarget.vue?vue&type=template&id=0a9af6ae&"
import script from "./myTarget.vue?vue&type=script&lang=js&"
export * from "./myTarget.vue?vue&type=script&lang=js&"
import style0 from "./myTarget.vue?vue&type=style&index=0&id=0a9af6ae&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports